import * as T from "../Controls.style";
import { get } from "lodash";
import { Inputs } from "@/components/atoms/Inputs";
import { ChangeEvent } from "react";
import { Control, Controller } from "react-hook-form";

interface TextControlProps {
  max?: string;
  name: string;
  type?: string;
  value?: any;
  label?: string;
  control: Control<any>;
  tabIndex?: number;
  required?: boolean;
  disabled?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  defaultValue?: string;
  instructions?: string;
}

export const TextControl = ({
  max,
  name,
  label,
  value,
  control,
  required,
  tabIndex,
  onChange,
  placeholder,
  instructions,
  defaultValue,
  type = "text",
  disabled = false,
}: TextControlProps) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, formState }) => (
        <>
          <T.Controls>
            <Inputs label={label} required={required ? required : false}>
              <input
                autoCapitalize="none"
                type={type}
                {...field}
                placeholder={placeholder}
                max={max}
                tabIndex={tabIndex}
                disabled={disabled}
                value={value}
                onChange={(e) => {
                  field.onChange(e);
                  if (onChange) onChange(e);
                }}
              />
            </Inputs>
            {instructions === "id" ? (
              <span style={{ color: "#B4B4BF" }}>
                <>ID는 영문 또는 숫자만 입력 가능합니다.</>
              </span>
            ) : instructions === "pw" ? (
              <span style={{ color: "#B4B4BF" }}>
                <>비밀번호는 8~20자 입력 가능합니다.</>
              </span>
            ) : get(formState.errors, name)?.message ? (
              <span>
                <>{get(formState.errors, name)?.message}</>
              </span>
            ) : null}
          </T.Controls>
        </>
      )}
    />
  );
};
